
function isTouchDevice (){

  let isTouch = ('ontouchstart' in document.documentElement);

  if ( isTouch ) {
    $('html').addClass('touch');
    return true
  }

  return false
}

export { isTouchDevice }
